import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  // Using your brand colors
  const colors = {
    primary: "#122721",
    background: "#6cf168",
    accent: "#36893B",
    light: "#f8f9fa",
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "What is Arbaah?",
      answer: "Arbaah is a comprehensive financial management platform designed specifically for UAE businesses. Our solution combines voice-to-invoice technology, document scanning, tax compliance monitoring, and real-time financial analytics to streamline your business operations and ensure compliance with UAE tax regulations."
    },
    {
      question: "How does Arbaah work?",
      answer: "Arbaah offers two ways to manage your finances: 1) Self-Service: Use our intuitive app to create invoices with voice commands, scan documents, track expenses, and monitor tax compliance. 2) Managed Service: Let our financial experts handle your bookkeeping and tax compliance while you focus on growing your business. After registering, you can immediately start creating invoices and tracking your finances."
    },
    {
      question: "How much does Arbaah cost?",
      answer: "Arbaah offers a free Basic plan for simple invoicing, excluding OCR and Voice features. The Starter plan is 109 AED/month with Voice-to-Invoice (200x) and tax automation. The Growth plan is 199 AED/month with 500x Voice-to-Invoice, 500x OCR scans, and advanced analytics. Enterprise plans are custom-made for large businesses."
    },
    {
      question: "Where can I find tax compliance tips?",
      answer: "Staying compliant with UAE tax regulations is essential for your business. Arbaah provides built-in compliance alerts and guidance directly in the app. Additionally, we offer a comprehensive Tax Compliance Guide in our Resources section. This guide covers VAT, corporate tax, and other UAE-specific tax requirements. Our blog also features regular updates on new tax laws and regulations."
    },
    {
      question: "Is my financial data secure with Arbaah?",
      answer: "Absolutely. Security is our top priority. Arbaah uses bank-level encryption (256-bit SSL) to protect all your data. We implement strict access controls, regular security audits, and comply with international data protection standards. Your financial information is stored on secure servers within the UAE, ensuring compliance with local data residency requirements."
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-white" id="faq">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Left column - Title and CTA */}
          <div className="lg:col-span-5">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4" style={{ color: colors.primary }}>
              What You Need to Know
            </h2>
            <p className="text-base md:text-lg mb-6 md:mb-8 text-gray-600">
              Our expert-developed app helps thousands of UAE businesses manage their finances and tax compliance every year.
            </p>
            <a 
              href="https://app.arbaah.ae/authentication/sign-up" 
              className="inline-flex items-center px-5 py-2.5 md:px-6 md:py-3 rounded-full text-white font-medium transition-all text-sm md:text-base"
              style={{ backgroundColor: "#51ba4e" }}
            >
              Start for free now
              <div className="relative ml-2 w-5 h-5 md:w-6 md:h-6 rounded-full bg-white/20 flex items-center justify-center">
                <svg className="w-3 h-3 md:w-4 md:h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </a>
          </div>

          {/* Right column - Accordion */}
          <div className="lg:col-span-6 lg:col-start-7">
            {faqItems.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-lg shadow-md mb-3 md:mb-4 overflow-hidden transition-all duration-300"
                style={{ 
                  boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.08), 1px 2px 8px rgba(0, 0, 0, 0.08)"
                }}
              >
                <button
                  className="w-full px-4 py-3 md:px-6 md:py-4 text-left flex justify-between items-center"
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-${index}-content`}
                >
                  <span className="font-medium text-base md:text-lg pr-2" style={{ color: colors.primary }}>
                    {faq.question}
                  </span>
                  <div className={`transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <ChevronDown size={20} color={colors.primary} />
                  </div>
                </button>

                <div 
                  id={`faq-${index}-content`}
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-4 pb-3 md:px-6 md:pb-4 text-gray-600">
                    <p className="text-sm md:text-base">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}

          
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;